<template>
  <div class="box">
    <div class="back" v-on:click="back">
      <img src="../assets/GoBack.png" alt />
    </div>
    <div class="title">常见问题</div>
    <div class="QuestionBox">
      <!-- <router-link to="/MyQuestionDetail"> -->
      <!-- <div class="Question">
        <div>·常见问题</div>
        <img src alt />
        <img src="../assets/right.png" alt />
      </div>-->
      <!-- </router-link> -->
      <router-link
        v-for="(item,index) in MyQuestionList"
        :key="index"
        :to="{ name: 'MyQuestionDetail', query: { 'detail': item}}"
      >
        <div class="Question">
          <div>{{item.title}}</div>
          <img src="../assets/right.png" alt />
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "box",
  data() {
    return {
      MyQuestionList: [],
    };
  },
  components: {},
  created() {},
  mounted() {

    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    var location = JSON.parse(localStorage.getItem("ZQlocation"));
    this.$store.commit("location", location);
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo
    });
    this.$store.commit(
      "UserSelf",
      JSON.parse(localStorage.getItem("ZQUserSelf"))
    );
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;
    this.GetMyQuestion();
  },
  methods: {
    //获取问题
    GetMyQuestion() {
      if (!this.$store.state.loading) {
        this.$store.commit("showLoading", true); //显示加载图标
        this.$http
          .get("/api/Problem/list", {
            params: {}
          })
          .then(res => {
            if (res.data.code == 1) {
              console.log(res.data);
              var QuestionList = res.data.data.action;
              QuestionList.map(item => {
                this.MyQuestionList.push(item);
              });
              this.$store.commit("showLoading", false); //关闭加载图标
            } else {
              this.$store.commit("showLoading", false); //关闭加载图标
            }
          });
      }
    },
    back() {
      this.$router.go(-1);
    }
  },
};
</script>
<style lang='scss' scoped>
.box {
  width: 7.5rem;
  height: 100vh;
  background: white;
}
.title {
  font-size: 0.32rem;
  line-height: 0.9rem;
  text-align: center;
  border-bottom: 1px solid #e5e5e5;
}
.back {
  position: absolute;
  top: 0.3rem;
  left: 0.2rem;
  width: 0.4rem;
  height: 0.4rem;
  z-index: 1000;
}
.back img {
  width: 100%;
  height: 100%;
  display: inline-block;
}
.QuestionBox {
  padding: 0.2rem;
  padding-bottom: 0.4rem;
  font-size: 0.28rem;
  background: #f5f5f5;
  margin: 0.3rem;
  margin-bottom: 0;
  border-radius: 0.2rem;
}
.Question {
  line-height: 0.4rem;
  padding: 0.2rem 0;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  word-break: break-all;
}
.Question img {
  width: 0.4rem;
  height: 0.4rem;
}
</style>
